import httpRequest from '../request/indexBase'
const perModuleType = '0'

// OBS获取AK,SK,ST
export function queryObsAKSKST() {
  return httpRequest.get({
    url: `/video/obsToken/queryObsAKSKST`
  })
}

// 查询链接导入列表
export function getList(data) {
  return httpRequest.post({
    url: `/repository/files-record/getUploadProgress`,
    data
  })
}

// 保存总结到知识库
export function saveFileTypeVideoSummary(data, perFolderId = '') {
  return httpRequest.post({
    url: `/video/video-abstract-summary/saveSummaryToWeAviate`,
    data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}
